import React from 'react';
import PropTypes from 'prop-types';
import { useDividerGradient } from '../gradient-utils';

export function CurveConcave({
  className,
  depth = 50,
  position = 50,
  fadeOpacity,
  fadeDirection,
  softness,
  style
}) {
  const { defs, fill, mask } = useDividerGradient({ fadeOpacity, fadeDirection, softness });

  // depth 0 = flat, depth 100 = curve bottom at y=120
  const curveY = (depth / 100) * 120;
  // position 0 = left (x=200), 50 = center (x=600), 100 = right (x=1000)
  const controlX = 200 + (position / 100) * 800;

  return (
    <svg
      className={ className }
      style={ style }
      viewBox='0 0 1200 120'
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      { defs }
      <path d={ `M0,0 Q${controlX},${curveY} 1200,0 L1200,120 L0,120 Z` } fill={ fill } mask={ mask } />
    </svg>
  );
}

CurveConcave.propTypes = {
  className: PropTypes.string,
  depth: PropTypes.number,
  position: PropTypes.number,
  fadeOpacity: PropTypes.number,
  fadeDirection: PropTypes.oneOf(['down', 'up', 'left', 'right']),
  softness: PropTypes.number
};
